import UnauthorizedRoute from './UnauthorizedRouteContainer';

export default UnauthorizedRoute;
